import { ApprovalSettingsFeaturePage } from "../ui";

/** 审批设置业务路由。 */
export function ApprovalSettingsPage() {
  return <ApprovalSettingsFeaturePage />;
}
